import { z } from 'zod';
import { secretProviderSchema } from './managed-secrets.js';

export const connectedAppFlowTypeSchema = z.enum(['client_credentials', 'authorization_code']);
export type ConnectedAppFlowType = z.infer<typeof connectedAppFlowTypeSchema>;

export const connectedAppDataSchema = z.object({
  clientId: z.string(),
  clientSecret: z.string(),
  scopes: z.string(),
  issuerUrl: z.string(),
});

export const connectedAppsTableItemSchema = z.object({
  id: z.number(),
  identifier: z.string(),
  name: z.string(),
  flowType: connectedAppFlowTypeSchema,
  createdOn: z.coerce.date(),
  createdBy: z.object({
    id: z.number(),
    name: z.string(),
  }).nullable(),
});

export const connectedAppSchema = z.object({
  id: z.number(),
  identifier: z.string(),
  secretRef: z.string(),
  provider: secretProviderSchema,
  name: z.string(),
});
export type ConnectedApp = z.infer<typeof connectedAppSchema>;

export const connectedAppDetailsSchema = z.object({
  id: z.coerce.number(),
  identifier: z.string(),
  flowType: connectedAppFlowTypeSchema,
  name: z.string(),
  data: connectedAppDataSchema,
});

export type ConnectedAppDetails = z.infer<typeof connectedAppDetailsSchema>;